const it = {
	Credentials: "Credenziali",
	Logout: "Esci",
	"My Credentials": "Le Mie Credenziali",
	"Issue Date": "Data Emissione",
	By: "Per",
	View: "Visualizza",
	Verify: "Verifica",
	purchase_for: "Acquista per",
	"Terms of Service": "Termini di Servizio",
	"Privacy & Data Protection": "Privacy e Protezione dei Dati",
	"Customer Support": "Assistenza Clienti",
	"Help Center": "Help Center",
	"Verify Certificate": "Verifica Certificato",
	"View Certificate": "Visualizza Certificato",
	Inbox: "Posta in entrata",
	//to do
	"Open Issuers App": "Emittenten-App",
	Name: "Name",
	"You are purchasing": "Sie kaufen",
	"Payment info": "Zahlungsinformationen",
	Email: "Email",
};
export default it;
